<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
					<div class="modal-title">
						{{ modalTitle }}
					</div>
					<div class="modal-header__close-button" @click="closeModal">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M18 6L6 18M6 6L18 18" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
                </div>
				<div class="modal-body">
                    <div class="modal-item"
                        v-for="(item, index) in items" :key="item.id">
                        {{ item.name }}
                        <svg @click="removeItem(index, item.id)" class="modal-item__button" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_641_26163)">
                                <path d="M12 4L4 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4 4L12 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_641_26163">
                                    <rect width="16" height="16" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
				</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "NotificationModal",
    props: {
		modalTitle: {
			type: String,
			default: 'Title',
			Required: true
		},
		items: {
			type: Array,
			default: [],
			Required: true
		}
    },
    emits: "closeModal",
    methods: {
        closeModal: function() {
            this.$emit('closeModal');
        },
        removeItem: async function (index) {
            this.items.splice(index, 1);
        },
    },
}
</script>

<style scoped lang="scss">
    .modal-title {
        font-size: 18px;
        font-weight: 600;
    }
    .modal-body {
        max-height: 340px;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        overflow-y: auto;
        width: 100%;
        gap: 8px;
    }
    .modal-item {
        border: 1px solid #EAEEF4;
        border-radius: 5px;
        padding: 5px 8px;
        &__button {
            cursor: pointer;
        }
        &__button:hover {
            path {
                stroke: red;
                transition: stroke 0.15s ease;
            }
        }
    }
</style>
